import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const SetupBridging = () => {
  const navigate = useNavigate();

  const getApiUrl = () =>
    localStorage.getItem('api_url') || localStorage.getItem('apiUrl') || 'http://localhost:8000';

  const [username, setUsername] = useState('Administrator');
  const [menus, setMenus] = useState([]);
  const [time, setTime] = useState({ date: '', clock: '' });
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [showSecretKey, setShowSecretKey] = useState(false);
  const [showEclaimKey, setShowEclaimKey] = useState(false);
  const [showEhrKey, setShowEhrKey] = useState(false);
  const [copiedField, setCopiedField] = useState(null);
  const [testingBpjs, setTestingBpjs] = useState(false);
  const [testingEclaim, setTestingEclaim] = useState(false);
  const [testingEhr, setTestingEhr] = useState(false);
  const [bpjsStatus, setBpjsStatus] = useState(null); // null | 'ok' | 'error'
  const [eclaimStatus, setEclaimStatus] = useState(null);
  const [ehrStatus, setEhrStatus] = useState(null);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  const [config, setConfig] = useState({
    NM_RS: '',
    APLICARES_BASE_URL: '',
    APLICARES_CONS_ID: '',
    APLICARES_KD_RS: '',
    APLICARES_SECRET_KEY: '',
    ECLAIM_URL: '',
    ECLAIM_KEY: '',
    KODE_TARIF: '',
    ECLAIM_CODER_NIK: '',
    EHR_URL: '',
    EHR_KEY: ''
  });

  // ── Init ──────────────────────────────────────────────────────
  useEffect(() => {
    const savedUser = localStorage.getItem('nama_user') || localStorage.getItem('user');
    if (savedUser) setUsername(savedUser);
    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) { try { setMenus(JSON.parse(savedMenu)); } catch(e){} }

    const tick = () => {
      const now = new Date();
      setTime({
        date: now.toLocaleDateString('id-ID', { weekday:'long', year:'numeric', month:'long', day:'numeric' }),
        clock: now.toLocaleTimeString('id-ID')
      });
    };
    tick();
    const timer = setInterval(tick, 1000);
    fetchConfig();
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Fetch ─────────────────────────────────────────────────────
  const fetchConfig = useCallback(async () => {
    setIsLoading(true);
    const apiUrl = getApiUrl();
    const token = localStorage.getItem('token') || '';
    try {
      let res = await fetch(`${apiUrl}/setup_bridging`, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
      });
      if (!res.ok) {
        res = await fetch(`${apiUrl}/setup_bridging`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
          body: JSON.stringify({})
        });
      }
      if (res.ok) {
        const json = await res.json();
        const data = json.data || json;
        if (data && typeof data === 'object' && Object.keys(data).length > 0) {
          setConfig(prev => ({ ...prev, ...data }));
          showToast('Konfigurasi berhasil dimuat dari server.', 'success');
          return;
        }
      }
      throw new Error('empty');
    } catch {
      setConfig({
        NM_RS: 'RS MARY CILEUNGSI HIJAU',
        APLICARES_BASE_URL: 'https://new-api.bpjs-kesehatan.go.id/aplicaresws/rest',
        APLICARES_CONS_ID: '23088',
        APLICARES_KD_RS: '0117R075',
        APLICARES_SECRET_KEY: '3xDAFD7161',
        ECLAIM_URL: 'http://100.2.0.2/eklaim/ws.php',
        ECLAIM_KEY: '3f15071dead14a609d977489dea4e94ac0be81fd022be74778be29e7b7b53a9d',
        KODE_TARIF: 'AP',
        ECLAIM_CODER_NIK: '1234567890123456',
        EHR_URL: 'https://rekam-medis.api.linimasa.co.id/graphql',
        EHR_KEY: ''
      });
      showToast('Server offline — data demo ditampilkan.', 'warning');
    } finally {
      setIsLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Save ──────────────────────────────────────────────────────
  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    const apiUrl = getApiUrl();
    const token = localStorage.getItem('token') || '';
    try {
      const res = await fetch(`${apiUrl}/save_setup_bridging`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify(config)
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const json = await res.json();
      showToast(json.message || json.msg || 'Konfigurasi berhasil disimpan!', 'success');
    } catch(err) {
      showToast('Gagal menyimpan. Pastikan API tersedia.', 'error');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Test Connection ───────────────────────────────────────────
  const testBpjs = async () => {
    setTestingBpjs(true); setBpjsStatus(null);
    try {
      await fetch(config.APLICARES_BASE_URL.split('/rest')[0] + '/rest', { mode: 'no-cors' });
      setBpjsStatus('ok');
    } catch { setBpjsStatus('error'); }
    finally { setTestingBpjs(false); }
  };
  const testEclaim = async () => {
    setTestingEclaim(true); setEclaimStatus(null);
    try {
      await fetch(config.ECLAIM_URL, { mode: 'no-cors' });
      setEclaimStatus('ok');
    } catch { setEclaimStatus('error'); }
    finally { setTestingEclaim(false); }
  };
  const testEhr = async () => {
    setTestingEhr(true); setEhrStatus(null);
    try {
      if (!config.EHR_URL) throw new Error('Empty URL');
      await fetch(config.EHR_URL, { mode: 'no-cors' });
      setEhrStatus('ok');
    } catch { setEhrStatus('error'); }
    finally { setTestingEhr(false); }
  };

  // ── Helpers ───────────────────────────────────────────────────
  const showToast = (message, type) => setToast({ show: true, message, type: type || 'success' });

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConfig(prev => ({ ...prev, [name]: value }));
  };

  const getMenuIcon = (name) => {
    if (!name) return 'bi-folder';
    const n = name.toUpperCase();
    if (n.includes('SETTING') || n.includes('BRIDGING')) return 'bi-gear';
    if (n.includes('PENAGIHAN') || n.includes('FINANCE')) return 'bi-cash-coin';
    if (n.includes('KASIR')) return 'bi-wallet2';
    if (n.includes('MASTER') || n.includes('DATA')) return 'bi-database';
    if (n.includes('PENUNJANG')) return 'bi-clipboard-pulse';
    if (n.includes('RAWAT') || n.includes('PENDAFTARAN')) return 'bi-hospital';
    return 'bi-chevron-right';
  };

  // ─── STYLES (inline) ─────────────────────────────────────────
  const S = {
    page: { minHeight:'100vh', background:'#f0f4f8', fontFamily:"'Inter','Segoe UI',sans-serif", display:'flex', flexDirection:'column' },
    nav: { background:'linear-gradient(135deg,#0f172a 0%,#1e293b 100%)', borderBottom:'2px solid #22c55e', padding:'0 0.8rem', height:'44px', display:'flex', alignItems:'center', position:'sticky', top:0, zIndex:100, flexShrink:0 },
    brand: { display:'flex', alignItems:'center', gap:'6px', textDecoration:'none', marginRight:'auto' },
    brandIcon: { width:'26px', height:'26px', background:'linear-gradient(135deg,#22c55e,#16a34a)', borderRadius:'6px', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, color:'#fff', fontSize:'14px' },
    brandText: { color:'#fff', fontWeight:700, fontSize:'0.82rem', lineHeight:1.2 },
    brandSub: { color:'#94a3b8', fontSize:'0.6rem', fontWeight:400 },
    navLink: { color:'rgba(255,255,255,0.65)', fontSize:'0.7rem', fontWeight:500, padding:'0.2rem 0.5rem', borderRadius:'6px', textDecoration:'none', display:'inline-flex', alignItems:'center', gap:'4px', transition:'all .15s', border:'none', background:'none', cursor:'pointer', whiteSpace:'nowrap' },
    navLinkHover: { color:'#fff', background:'rgba(255,255,255,0.1)' },
    clock: { color:'#64748b', fontSize:'0.65rem', textAlign:'right', lineHeight:1.4 },
    clockTime: { color:'#22c55e', fontWeight:700, fontSize:'0.75rem' },
    btnHome: { display:'inline-flex', alignItems:'center', gap:'4px', padding:'0.2rem 0.5rem', background:'#f59e0b', color:'#1c1917', border:'none', borderRadius:'6px', fontWeight:700, fontSize:'0.68rem', cursor:'pointer', transition:'all .15s', flexShrink:0 },
    main: { flex:1, padding:'0.75rem 0.5rem', overflowY:'auto' },
    maxW: { width:'100%', margin:'0 auto' },
    // Hero bar
    heroBar: { background:'linear-gradient(135deg,#1e293b 0%,#0f172a 100%)', borderRadius:'12px', padding:'0.75rem 1rem', marginBottom:'0.65rem', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:'0.75rem', boxShadow:'0 4px 24px rgba(0,0,0,0.12)' },
    heroTitle: { color:'#fff', fontWeight:800, fontSize:'1rem', margin:0, lineHeight:1.2 },
    heroSub: { color:'#94a3b8', fontSize:'0.72rem', marginTop:'2px' },
    heroBadge: { display:'inline-flex', alignItems:'center', gap:'4px', padding:'0.25rem 0.6rem', borderRadius:'999px', fontSize:'0.65rem', fontWeight:600 },
    // Section
    sectionLabel: { fontSize:'0.62rem', fontWeight:700, letterSpacing:'1px', textTransform:'uppercase', color:'#94a3b8', marginBottom:'0.4rem', display:'flex', alignItems:'center', gap:'6px' },
    sectionLine: { flex:1, height:'1px', background:'#e2e8f0' },
    // Card
    card: { background:'#fff', borderRadius:'12px', overflow:'hidden', boxShadow:'0 2px 12px rgba(0,0,0,0.06)', border:'1px solid #f1f5f9', marginBottom:'0.75rem' },
    cardHead: { padding:'0.6rem 0.8rem', display:'flex', alignItems:'center', justifyContent:'space-between', borderBottom:'1px solid #f1f5f9' },
    cardHeadLeft: { display:'flex', alignItems:'center', gap:'8px' },
    cardIcon: { width:'28px', height:'28px', borderRadius:'8px', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'13px', flexShrink:0, color:'#fff' },
    cardTitle: { fontWeight:700, fontSize:'0.78rem', color:'#0f172a', margin:0 },
    cardSub: { fontSize:'0.65rem', color:'#94a3b8', margin:0 },
    cardBody: { padding:'0.75rem 0.8rem' },
    // Field
    fieldLabel: { fontSize:'0.65rem', fontWeight:600, color:'#64748b', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'flex', alignItems:'center', gap:'4px' },
    input: { width:'100%', padding:'0.45rem 0.6rem', border:'1.5px solid #e2e8f0', borderRadius:'8px', fontSize:'0.78rem', color:'#0f172a', background:'#f8fafc', transition:'border-color .15s, box-shadow .15s', outline:'none', boxSizing:'border-box' },
    inputFocus: { borderColor:'#3b82f6', boxShadow:'0 0 0 3px rgba(59,130,246,.12)' },
    inputGroup: { display:'flex', gap:0, border:'1.5px solid #e2e8f0', borderRadius:'8px', overflow:'hidden', background:'#f8fafc' },
    inputGroupField: { flex:1, padding:'0.45rem 0.6rem', border:'none', fontSize:'0.78rem', color:'#0f172a', background:'transparent', outline:'none', fontFamily:'monospace', letterSpacing:'0.5px' },
    inputGroupBtn: { padding:'0 0.6rem', background:'#f1f5f9', border:'none', borderLeft:'1px solid #e2e8f0', cursor:'pointer', color:'#64748b', transition:'all .15s', display:'flex', alignItems:'center', gap:'4px', fontSize:'0.68rem', fontWeight:600 },
    // Status dot
    dot: { width:'6px', height:'6px', borderRadius:'50%', display:'inline-block', flexShrink:0 },
    // Textarea
    textarea: { width:'100%', padding:'0.5rem 0.6rem', border:'1.5px solid #e2e8f0', borderRadius:'8px', fontSize:'0.78rem', color:'#0f172a', background:'#f8fafc', fontFamily:'monospace', resize:'vertical', minHeight:'65px', outline:'none', boxSizing:'border-box', lineHeight:1.4 },
    // Action bar
    actionBar: { background:'#fff', borderTop:'1px solid #f1f5f9', padding:'0.6rem 0.8rem', display:'flex', alignItems:'center', justifyContent:'flex-end', gap:'0.6rem', borderRadius:'0 0 12px 12px' },
    btnCancel: { padding:'0.4rem 1rem', background:'#f1f5f9', color:'#475569', border:'none', borderRadius:'8px', fontWeight:600, fontSize:'0.75rem', cursor:'pointer', transition:'all .15s' },
    btnSave: { padding:'0.4rem 1.25rem', background:'linear-gradient(135deg,#3b82f6 0%,#2563eb 100%)', color:'#fff', border:'none', borderRadius:'8px', fontWeight:700, fontSize:'0.75rem', cursor:'pointer', transition:'all .15s', display:'inline-flex', alignItems:'center', gap:'4px', boxShadow:'0 4px 12px rgba(59,130,246,.3)' },
    btnTest: { display:'inline-flex', alignItems:'center', gap:'4px', padding:'0.25rem 0.6rem', borderRadius:'6px', fontSize:'0.65rem', fontWeight:600, cursor:'pointer', border:'1.5px solid', transition:'all .15s' },
    // Toast
    toastWrap: { position:'fixed', bottom:'1.5rem', right:'1.5rem', zIndex:9999 },
    toast: { padding:'0.6rem 0.85rem', borderRadius:'8px', fontSize:'0.78rem', fontWeight:600, display:'flex', alignItems:'center', gap:'8px', boxShadow:'0 8px 24px rgba(0,0,0,0.15)', maxWidth:'280px', animation:'fadeInUp .25s ease' },
  };

  const statusBadge = (status) => {
    if (status === 'ok') return { bg:'rgba(34,197,94,.15)', color:'#15803d', dot:'#22c55e', text:'Connected' };
    if (status === 'error') return { bg:'rgba(239,68,68,.12)', color:'#dc2626', dot:'#ef4444', text:'Unreachable' };
    return { bg:'rgba(100,116,139,.1)', color:'#64748b', dot:'#94a3b8', text:'Belum diuji' };
  };

  const bpjsBadge = statusBadge(bpjsStatus);
  const eclaimBadge = statusBadge(eclaimStatus);
  const ehrBadge = statusBadge(ehrStatus);

  // ── Render ────────────────────────────────────────────────────
  if (isLoading) {
    return (
      <div style={{ ...S.page, alignItems:'center', justifyContent:'center', gap:'1rem' }}>
        <div style={{ width:'44px', height:'44px', border:'3px solid #e2e8f0', borderTopColor:'#3b82f6', borderRadius:'50%', animation:'spin 0.8s linear infinite' }}></div>
        <div style={{ color:'#64748b', fontSize:'0.9rem', fontWeight:600 }}>Memuat konfigurasi...</div>
        <style>{`@keyframes spin{to{transform:rotate(360deg)}} @keyframes fadeInUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}`}</style>
      </div>
    );
  }

  return (
    <div style={S.page}>
      <style>{`
        @keyframes spin{to{transform:rotate(360deg)}}
        @keyframes fadeInUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:.5}}
        .sb-input:focus{border-color:#3b82f6!important;box-shadow:0 0 0 3px rgba(59,130,246,.12)!important;}
        .sb-textarea:focus{border-color:#3b82f6!important;box-shadow:0 0 0 3px rgba(59,130,246,.12)!important;}
        .sb-ig:focus-within{border-color:#3b82f6!important;box-shadow:0 0 0 3px rgba(59,130,246,.12)!important;}
        .sb-nav-link:hover{color:#fff!important;background:rgba(255,255,255,0.1)!important;}
        .sb-btn-cancel:hover{background:#e2e8f0!important;}
        .sb-btn-save:hover{transform:translateY(-1px);box-shadow:0 6px 18px rgba(59,130,246,.4)!important;}
        .sb-btn-home:hover{background:#fbbf24!important;transform:translateY(-1px);}
        .sb-btn-test:hover{opacity:.85;}
        .sb-ig-btn:hover{background:#e2e8f0!important;color:#334155!important;}
        .sb-grid-services{display:grid;grid-template-columns:repeat(3, 1fr);gap:1.1rem;margin-bottom:1.25rem;}
        @media(max-width:1200px){
          .sb-grid-services{grid-template-columns:repeat(2, 1fr)!important;}
        }
        @media(max-width:768px){
          .sb-hero{flex-direction:column!important;text-align:center;}
          .sb-grid-2{grid-template-columns:1fr!important;}
          .sb-grid-3{grid-template-columns:1fr!important;}
          .sb-grid-services{grid-template-columns:1fr!important;}
        }
      `}</style>

      {/* ── NAVBAR ────────────────────────────────────────────── */}
      <nav style={S.nav}>
        <a style={S.brand} href="#home" onClick={e=>{e.preventDefault();navigate('/home');}}>
          <div style={S.brandIcon}>
            <i className="bi bi-link-45deg" style={{fontSize: '22px'}}></i>
          </div>
          <div>
            <div style={S.brandText}>SIMRS2 <span style={{color:'#22c55e',fontWeight:500}}>Bridging</span></div>
            <div style={S.brandSub}>Konfigurasi Integrasi Sistem</div>
          </div>
        </a>

        <div style={{display:'flex', alignItems:'center', gap:'1rem'}}>
          {/* Nav links */}
          <div style={{display:'flex', gap:'2px', flexWrap:'wrap'}}>
            {menus.slice(0,5).map(item => (
              <button
                key={item.id_mn}
                className="sb-nav-link"
                style={S.navLink}
                onClick={() => navigate('/home')}
              >
                <i className={`bi ${getMenuIcon(item.des_mn)}`}></i>
                {(item.des_mn||'').replace(/\b\w/g, s=>s.toUpperCase())}
              </button>
            ))}
          </div>

          {/* Clock */}
          <div style={{...S.clock, borderLeft:'1px solid rgba(255,255,255,0.1)', paddingLeft:'1rem', display:'none'}} className="d-none d-lg-block">
            <div style={{color:'#94a3b8',fontSize:'0.68rem'}}>{time.date}</div>
            <div style={S.clockTime}>{time.clock}</div>
          </div>

          {/* User */}
          <div style={{display:'flex', alignItems:'center', gap:'6px'}}>
            <div style={{width:'30px',height:'30px',borderRadius:'50%',background:'linear-gradient(135deg,#f59e0b,#d97706)',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:700,fontSize:'0.8rem',flexShrink:0}}>
              {username.charAt(0).toUpperCase()}
            </div>
            <span style={{color:'rgba(255,255,255,0.8)',fontSize:'0.78rem',fontWeight:600,display:'none'}} className="d-none d-md-inline">{username}</span>
          </div>

          {/* Home btn */}
          <button className="sb-btn-home" style={S.btnHome} onClick={() => navigate('/home')}>
            <i className="bi bi-house-door-fill"></i>
            <span style={{display:'none'}} className="d-none d-sm-inline">Home</span>
          </button>
        </div>
      </nav>

      {/* ── MAIN ──────────────────────────────────────────────── */}
      <main style={S.main}>
        <div style={S.maxW}>

          {/* Hero Bar */}
          <div style={S.heroBar} className="sb-hero">
            <div>
              <div style={{display:'flex', alignItems:'center', gap:'10px', marginBottom:'4px'}}>
                <div style={{width:'40px',height:'40px',borderRadius:'12px',background:'rgba(34,197,94,.15)',border:'1px solid rgba(34,197,94,.25)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'20px',color:'#22c55e'}}>
                  <i className="bi bi-gear-wide-connected"></i>
                </div>
                <h1 style={S.heroTitle}>Setup Konfigurasi Bridging</h1>
              </div>
              <p style={S.heroSub}>Kelola koneksi BPJS APLICARES, E-Klaim INA-CBG's, dan EHR Rekam Medis dalam satu halaman.</p>
            </div>
            <div style={{display:'flex', alignItems:'center', gap:'0.75rem'}}>
              <div style={{...S.heroBadge, background:bpjsBadge.bg, color:bpjsBadge.color}}>
                <span style={{...S.dot, background:bpjsBadge.dot, boxShadow: bpjsStatus==='ok'?'0 0 0 3px rgba(34,197,94,.2)':''}}></span>
                BPJS: {bpjsBadge.text}
              </div>
              <div style={{...S.heroBadge, background:eclaimBadge.bg, color:eclaimBadge.color}}>
                <span style={{...S.dot, background:eclaimBadge.dot, boxShadow: eclaimStatus==='ok'?'0 0 0 3px rgba(34,197,94,.2)':''}}></span>
                E-Klaim: {eclaimBadge.text}
              </div>
              <div style={{...S.heroBadge, background:ehrBadge.bg, color:ehrBadge.color}}>
                <span style={{...S.dot, background:ehrBadge.dot, boxShadow: ehrStatus==='ok'?'0 0 0 3px rgba(34,197,94,.2)':''}}></span>
                EHR: {ehrBadge.text}
              </div>
              <button
                onClick={fetchConfig}
                style={{...S.btnTest, borderColor:'rgba(255,255,255,0.15)', color:'rgba(255,255,255,0.75)', background:'rgba(255,255,255,0.07)'}}
                className="sb-btn-test"
              >
                <i className="bi bi-arrow-clockwise"></i> Reload
              </button>
            </div>
          </div>

          {/* ── Form ─────────────────────────────────────────── */}
          <form onSubmit={handleSave}>

            {/* SECTION 1: Informasi Rumah Sakit */}
            <div style={S.sectionLabel}>
              <span><i className="bi bi-building"></i> Identitas Instansi</span>
              <span style={S.sectionLine}></span>
            </div>

            <div style={S.card}>
              <div style={S.cardBody}>
                <label style={S.fieldLabel}>Nama Rumah Sakit Terdaftar (NM_RS)</label>
                <input
                  className="sb-input"
                  style={S.input}
                  type="text"
                  name="NM_RS"
                  value={config.NM_RS}
                  onChange={handleChange}
                  placeholder="Contoh: RS MARY CILEUNGSI HIJAU"
                />
                <div style={{fontSize:'0.72rem',color:'#94a3b8',marginTop:'6px'}}>
                  <i className="bi bi-info-circle me-1"></i> Nama ini akan muncul sebagai identitas pada seluruh header request bridging ke BPJS.
                </div>
              </div>
            </div>

            {/* SECTION 2: Layanan Bridging 3 Kolom */}
            <div style={S.sectionLabel}>
              <span><i className="bi bi-shield-check"></i> Konfigurasi Layanan Bridging (BPJS, E-Klaim &amp; EHR)</span>
              <span style={S.sectionLine}></span>
            </div>

            <div className="sb-grid-services">

              {/* CARD BPJS APLICARES */}
              <div style={S.card}>
                <div style={{...S.cardHead, background:'linear-gradient(90deg,rgba(22,163,74,.07) 0%,rgba(34,197,94,.04) 100%)'}}>
                  <div style={S.cardHeadLeft}>
                    <div style={{...S.cardIcon, background:'rgba(22,163,74,.12)', color:'#16a34a'}}>
                      <i className="bi bi-shield-shaded"></i>
                    </div>
                    <div>
                      <p style={S.cardTitle}>BPJS APLICARES</p>
                      <p style={S.cardSub}>VClaim &amp; SEP Integration</p>
                    </div>
                  </div>
                  <div style={{display:'flex', gap:'6px'}}>
                    <div style={{...S.heroBadge, background:bpjsBadge.bg, color:bpjsBadge.color, fontSize:'0.68rem', padding:'0.2rem 0.6rem'}}>
                      <span style={{...S.dot, background:bpjsBadge.dot, width:'6px', height:'6px'}}></span>
                      {bpjsBadge.text}
                    </div>
                  </div>
                </div>
                <div style={S.cardBody}>
                  <div style={{display:'flex', flexDirection:'column', gap:'1rem'}}>

                    {/* Base URL */}
                    <div>
                      <label style={S.fieldLabel}>Base URL</label>
                      <div className="sb-ig" style={{...S.inputGroup, borderRadius:'10px'}}>
                        <input
                          style={S.inputGroupField}
                          type="text"
                          name="APLICARES_BASE_URL"
                          value={config.APLICARES_BASE_URL}
                          onChange={handleChange}
                          placeholder="https://new-api.bpjs-kesehatan.go.id/..."
                        />
                        <button type="button" className="sb-ig-btn" style={S.inputGroupBtn} onClick={() => copyToClipboard(config.APLICARES_BASE_URL, 'apliUrl')}>
                          {copiedField==='apliUrl' ? <><i className="bi bi-check2"></i> Copied</> : <><i className="bi bi-clipboard"></i> Copy</>}
                        </button>
                      </div>
                    </div>

                    {/* Cons ID & Kode RS */}
                    <div className="sb-grid-3" style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'0.75rem'}}>
                      <div>
                        <label style={S.fieldLabel}>Consumer ID</label>
                        <div style={{position:'relative'}}>
                          <input
                            className="sb-input"
                            style={{...S.input, fontFamily:'monospace', fontWeight:700, color:'#3b82f6'}}
                            type="text"
                            name="APLICARES_CONS_ID"
                            value={config.APLICARES_CONS_ID}
                            onChange={handleChange}
                            placeholder="23088"
                          />
                          <button type="button" onClick={()=>copyToClipboard(config.APLICARES_CONS_ID,'consId')} style={{position:'absolute',right:'8px',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:copiedField==='consId'?'#22c55e':'#94a3b8',fontSize:'0.9rem'}}>
                            {copiedField==='consId' ? <i className="bi bi-check2"></i> : <i className="bi bi-clipboard"></i>}
                          </button>
                        </div>
                      </div>
                      <div>
                        <label style={S.fieldLabel}>Kode RS</label>
                        <div style={{position:'relative'}}>
                          <input
                            className="sb-input"
                            style={{...S.input, fontFamily:'monospace', fontWeight:700}}
                            type="text"
                            name="APLICARES_KD_RS"
                            value={config.APLICARES_KD_RS}
                            onChange={handleChange}
                            placeholder="0117R075"
                          />
                          <button type="button" onClick={()=>copyToClipboard(config.APLICARES_KD_RS,'kdRs')} style={{position:'absolute',right:'8px',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:copiedField==='kdRs'?'#22c55e':'#94a3b8',fontSize:'0.9rem'}}>
                            {copiedField==='kdRs' ? <i className="bi bi-check2"></i> : <i className="bi bi-clipboard"></i>}
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Secret Key */}
                    <div>
                      <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'6px'}}>
                        <label style={{...S.fieldLabel, marginBottom:0}}>Secret Key</label>
                        <div style={{display:'flex', gap:'6px'}}>
                          <button type="button" className="sb-ig-btn" style={{...S.inputGroupBtn, border:'1.5px solid #e2e8f0', borderRadius:'7px', padding:'0.2rem 0.65rem'}} onClick={()=>setShowSecretKey(!showSecretKey)}>
                            {showSecretKey ? <><i className="bi bi-eye-slash"></i> Hide</> : <><i className="bi bi-eye"></i> Show</>}
                          </button>
                          <button type="button" className="sb-ig-btn" style={{...S.inputGroupBtn, border:'1.5px solid #e2e8f0', borderRadius:'7px', padding:'0.2rem 0.65rem'}} onClick={()=>copyToClipboard(config.APLICARES_SECRET_KEY,'secKey')}>
                            {copiedField==='secKey' ? <><i className="bi bi-check2"></i> Copied</> : <><i className="bi bi-clipboard"></i> Copy</>}
                          </button>
                        </div>
                      </div>
                      <div className="sb-ig" style={{...S.inputGroup, borderRadius:'10px'}}>
                        <input
                          style={{...S.inputGroupField, letterSpacing: showSecretKey?'0.5px':'3px'}}
                          type={showSecretKey ? 'text' : 'password'}
                          name="APLICARES_SECRET_KEY"
                          value={config.APLICARES_SECRET_KEY}
                          onChange={handleChange}
                          placeholder="Secret Key"
                        />
                      </div>
                      <div style={{fontSize:'0.7rem',color:'#94a3b8',marginTop:'4px'}}>
                        Secret Key otorisasi BPJS Web Service &amp; HMAC Signature
                      </div>
                    </div>

                    {/* Test button */}
                    <button
                      type="button"
                      className="sb-btn-test"
                      style={{...S.btnTest, borderColor:'#16a34a', color:'#15803d', background:'rgba(22,163,74,.06)', width:'100%', justifyContent:'center', padding:'0.55rem', marginTop:'auto'}}
                      onClick={testBpjs}
                      disabled={testingBpjs}
                    >
                      {testingBpjs
                        ? <><i className="bi bi-arrow-repeat" style={{display:'inline-block',animation:'spin .8s linear infinite'}}></i> Menguji koneksi...</>
                        : <><i className="bi bi-plug"></i> Test Koneksi BPJS</>
                      }
                    </button>
                  </div>
                </div>
              </div>

              {/* CARD E-KLAIM */}
              <div style={S.card}>
                <div style={{...S.cardHead, background:'linear-gradient(90deg,rgba(2,132,199,.07) 0%,rgba(56,189,248,.04) 100%)'}}>
                  <div style={S.cardHeadLeft}>
                    <div style={{...S.cardIcon, background:'rgba(2,132,199,.12)', color:'#0284c7'}}>
                      <i className="bi bi-file-earmark-medical"></i>
                    </div>
                    <div>
                      <p style={S.cardTitle}>E-Klaim INA-CBG's</p>
                      <p style={S.cardSub}>Grouper &amp; Tarif Integration</p>
                    </div>
                  </div>
                  <div style={{...S.heroBadge, background:eclaimBadge.bg, color:eclaimBadge.color, fontSize:'0.68rem', padding:'0.2rem 0.6rem'}}>
                    <span style={{...S.dot, background:eclaimBadge.dot, width:'6px', height:'6px'}}></span>
                    {eclaimBadge.text}
                  </div>
                </div>
                <div style={S.cardBody}>
                  <div style={{display:'flex', flexDirection:'column', gap:'1rem'}}>

                    {/* E-Claim URL */}
                    <div>
                      <label style={S.fieldLabel}>Base URL</label>
                      <div className="sb-ig" style={{...S.inputGroup, borderRadius:'10px'}}>
                        <input
                          style={S.inputGroupField}
                          type="text"
                          name="ECLAIM_URL"
                          value={config.ECLAIM_URL}
                          onChange={handleChange}
                          placeholder="http://100.2.0.2/eklaim/ws.php"
                        />
                        <button type="button" className="sb-ig-btn" style={S.inputGroupBtn} onClick={()=>copyToClipboard(config.ECLAIM_URL,'eclaimUrl')}>
                          {copiedField==='eclaimUrl' ? <><i className="bi bi-check2"></i> Copied</> : <><i className="bi bi-clipboard"></i> Copy</>}
                        </button>
                      </div>
                    </div>

                    {/* Kode Tarif & NIK Coder Group */}
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <div style={{ flex: 1 }}>
                        <label style={S.fieldLabel}>Kode Tarif</label>
                        <select
                          className="sb-input"
                          style={{...S.inputGroupField, width:'100%', borderRadius:'10px', border:'1.5px solid #e2e8f0', padding:'0.55rem 0.6rem', background:'#f8fafc', fontSize:'0.8rem'}}
                          name="KODE_TARIF"
                          value={config.KODE_TARIF || ''}
                          onChange={handleChange}
                        >
                          <option value="">Pilih...</option>
                          <option value="AP">AP: RS Kelas A Pemerintah</option>
                          <option value="AS">AS: RS Kelas A Swasta</option>
                          <option value="BP">BP: RS Kelas B Pemerintah</option>
                          <option value="BS">BS: RS Kelas B Swasta</option>
                          <option value="CP">CP: RS Kelas C Pemerintah</option>
                          <option value="CS">CS: RS Kelas C Swasta</option>
                          <option value="DP">DP: RS Kelas D Pemerintah</option>
                          <option value="DS">DS: RS Kelas D Swasta</option>
                        </select>
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={S.fieldLabel}>NIK Coder</label>
                        <div className="sb-ig" style={{...S.inputGroup, borderRadius:'10px'}}>
                          <input
                            style={{...S.inputGroupField, fontSize:'0.8rem'}}
                            type="text"
                            name="ECLAIM_CODER_NIK"
                            value={config.ECLAIM_CODER_NIK || ''}
                            onChange={handleChange}
                            placeholder="Contoh: 317507..."
                            maxLength="16"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Encryption Key */}
                    <div>
                      <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'6px'}}>
                        <label style={{...S.fieldLabel, marginBottom:0}}>Encryption Key</label>
                        <div style={{display:'flex', gap:'6px'}}>
                          <button type="button" className="sb-ig-btn" style={{...S.inputGroupBtn, border:'1.5px solid #e2e8f0', borderRadius:'7px', padding:'0.2rem 0.65rem'}} onClick={()=>setShowEclaimKey(!showEclaimKey)}>
                            {showEclaimKey ? <><i className="bi bi-eye-slash"></i> Hide</> : <><i className="bi bi-eye"></i> Show</>}
                          </button>
                          <button type="button" className="sb-ig-btn" style={{...S.inputGroupBtn, border:'1.5px solid #e2e8f0', borderRadius:'7px', padding:'0.2rem 0.65rem'}} onClick={()=>copyToClipboard(config.ECLAIM_KEY,'eclaimKey')}>
                            {copiedField==='eclaimKey' ? <><i className="bi bi-check2"></i> Copied</> : <><i className="bi bi-clipboard"></i> Copy</>}
                          </button>
                        </div>
                      </div>
                      <textarea
                        className="sb-textarea"
                        style={{...S.textarea, filter: showEclaimKey?'none':'blur(4px)', transition:'filter .2s', userSelect: showEclaimKey?'auto':'none', height:'75px'}}
                        name="ECLAIM_KEY"
                        value={config.ECLAIM_KEY}
                        onChange={handleChange}
                        placeholder="Masukkan Encryption Key..."
                        rows={3}
                      />
                      <div style={{fontSize:'0.7rem',color:'#94a3b8',marginTop:'4px'}}>
                        Key 64-char SHA256 enkripsi Grouper INA-CBG's
                      </div>
                    </div>

                    {/* Test button */}
                    <button
                      type="button"
                      className="sb-btn-test"
                      style={{...S.btnTest, borderColor:'#0284c7', color:'#0369a1', background:'rgba(2,132,199,.06)', width:'100%', justifyContent:'center', padding:'0.55rem', marginTop:'auto'}}
                      onClick={testEclaim}
                      disabled={testingEclaim}
                    >
                      {testingEclaim
                        ? <><i className="bi bi-arrow-repeat" style={{display:'inline-block',animation:'spin .8s linear infinite'}}></i> Menguji koneksi...</>
                        : <><i className="bi bi-plug"></i> Test Koneksi E-Klaim</>
                      }
                    </button>
                  </div>
                </div>
              </div>

              {/* CARD EHR REKAM MEDIS */}
              <div style={S.card}>
                <div style={{...S.cardHead, background:'linear-gradient(90deg,rgba(139,92,246,.08) 0%,rgba(168,85,247,.04) 100%)'}}>
                  <div style={S.cardHeadLeft}>
                    <div style={{...S.cardIcon, background:'rgba(139,92,246,.15)', color:'#7c3aed'}}>
                      <i className="bi bi-hospital"></i>
                    </div>
                    <div>
                      <p style={S.cardTitle}>EHR Rekam Medis</p>
                      <p style={S.cardSub}>GraphQL &amp; Clinical Bridging</p>
                    </div>
                  </div>
                  <div style={{display:'flex', gap:'6px'}}>
                    <div style={{...S.heroBadge, background:ehrBadge.bg, color:ehrBadge.color, fontSize:'0.68rem', padding:'0.2rem 0.6rem'}}>
                      <span style={{...S.dot, background:ehrBadge.dot, width:'6px', height:'6px'}}></span>
                      {ehrBadge.text}
                    </div>
                  </div>
                </div>

                <div style={S.cardBody}>
                  <div style={{display:'flex', flexDirection:'column', gap:'1rem'}}>

                    {/* URL EHR */}
                    <div>
                      <label style={S.fieldLabel}>URL EHR (GraphQL / REST Endpoint)</label>
                      <div className="sb-ig" style={{...S.inputGroup, borderRadius:'10px'}}>
                        <input
                          style={S.inputGroupField}
                          type="text"
                          name="EHR_URL"
                          value={config.EHR_URL || ''}
                          onChange={handleChange}
                          placeholder="https://rekam-medis.api.linimasa.co.id/graphql"
                        />
                        <button type="button" className="sb-ig-btn" style={S.inputGroupBtn} onClick={()=>copyToClipboard(config.EHR_URL,'ehrUrl')}>
                          {copiedField==='ehrUrl' ? <><i className="bi bi-check2"></i> Copied</> : <><i className="bi bi-clipboard"></i> Copy</>}
                        </button>
                      </div>
                    </div>

                    {/* Info Protokol & Standar */}
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <div style={{ flex: 1 }}>
                        <label style={S.fieldLabel}>Protokol</label>
                        <input
                          className="sb-input"
                          style={{...S.inputGroupField, width:'100%', borderRadius:'10px', border:'1.5px solid #e2e8f0', padding:'0.55rem 0.6rem', background:'#f8fafc', color:'#475569', fontWeight:600, fontSize:'0.8rem'}}
                          value="GraphQL / REST"
                          readOnly
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={S.fieldLabel}>Standar Integrasi</label>
                        <input
                          className="sb-input"
                          style={{...S.inputGroupField, width:'100%', borderRadius:'10px', border:'1.5px solid #e2e8f0', padding:'0.55rem 0.6rem', background:'#f8fafc', color:'#475569', fontWeight:600, fontSize:'0.8rem'}}
                          value="Linimasa / SatuSehat"
                          readOnly
                        />
                      </div>
                    </div>

                    {/* Secret Key / Token EHR */}
                    <div>
                      <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'6px'}}>
                        <label style={{...S.fieldLabel, marginBottom:0}}>Secret Key / Access Token EHR</label>
                        <div style={{display:'flex', gap:'6px'}}>
                          <button type="button" className="sb-ig-btn" style={{...S.inputGroupBtn, border:'1.5px solid #e2e8f0', borderRadius:'7px', padding:'0.2rem 0.65rem'}} onClick={()=>setShowEhrKey(!showEhrKey)}>
                            {showEhrKey ? <><i className="bi bi-eye-slash"></i> Hide</> : <><i className="bi bi-eye"></i> Show</>}
                          </button>
                          <button type="button" className="sb-ig-btn" style={{...S.inputGroupBtn, border:'1.5px solid #e2e8f0', borderRadius:'7px', padding:'0.2rem 0.65rem'}} onClick={()=>copyToClipboard(config.EHR_KEY,'ehrKey')}>
                            {copiedField==='ehrKey' ? <><i className="bi bi-check2"></i> Copied</> : <><i className="bi bi-clipboard"></i> Copy</>}
                          </button>
                        </div>
                      </div>
                      <textarea
                        className="sb-textarea"
                        style={{
                          ...S.textarea,
                          filter: showEhrKey ? 'none' : 'blur(4px)',
                          transition: 'filter .2s',
                          userSelect: showEhrKey ? 'auto' : 'none',
                          height:'75px'
                        }}
                        name="EHR_KEY"
                        value={config.EHR_KEY || ''}
                        onChange={handleChange}
                        placeholder="Bearer Token / Secret Key autentikasi EHR..."
                        rows={3}
                      />
                      <div style={{fontSize:'0.7rem', color:'#94a3b8', marginTop:'4px'}}>
                        Bearer token otorisasi query medis (Resume, Triase, SOAP, CPPT)
                      </div>
                    </div>

                    {/* Test Button EHR */}
                    <button
                      type="button"
                      className="sb-btn-test"
                      style={{...S.btnTest, borderColor:'#7c3aed', color:'#6d28d9', background:'rgba(139,92,246,.06)', width:'100%', justifyContent:'center', padding:'0.55rem', marginTop:'auto'}}
                      onClick={testEhr}
                      disabled={testingEhr}
                    >
                      {testingEhr
                        ? <><i className="bi bi-arrow-repeat" style={{display:'inline-block',animation:'spin .8s linear infinite'}}></i> Menguji koneksi EHR...</>
                        : <><i className="bi bi-plug"></i> Test Koneksi EHR</>
                      }
                    </button>

                  </div>
                </div>
              </div>

            </div>{/* end sb-grid-services */}

            {/* Action Bar */}
            <div style={{...S.card, overflow:'visible'}}>
              <div style={{...S.actionBar, borderRadius:'16px'}}>
                <div style={{marginRight:'auto', fontSize:'0.78rem', color:'#94a3b8', display:'flex', alignItems:'center', gap:'6px'}}>
                  <span style={{...S.dot, background:isLoading?'#f59e0b':'#22c55e', animation:isLoading?'pulse 1.5s infinite':''}}></span>
                  {isSaving ? 'Menyimpan...' : 'Siap disimpan'}
                </div>
                <button type="button" className="sb-btn-cancel" style={S.btnCancel} onClick={()=>navigate('/home')} disabled={isSaving}>
                  Batal
                </button>
                <button type="submit" className="sb-btn-save" style={{...S.btnSave, opacity:isSaving?.7:1}} disabled={isSaving}>
                  {isSaving
                    ? <><i className="bi bi-arrow-repeat" style={{display:'inline-block',animation:'spin .8s linear infinite'}}></i> Menyimpan...</>
                    : <><i className="bi bi-save2"></i> Simpan Konfigurasi</>
                  }
                </button>
              </div>
            </div>

          </form>
        </div>
      </main>

      {/* ── TOAST ─────────────────────────────────────────────── */}
      {toast.show && (
        <div style={S.toastWrap}>
          <div style={{
            ...S.toast,
            background: toast.type==='success'?'#0f172a':toast.type==='error'?'#dc2626':'#92400e',
            color:'#fff'
          }}>
            <span style={{fontSize:'1.1rem'}}>
              {toast.type==='success' ? <i className="bi bi-check-circle-fill text-success"></i> : toast.type==='error' ? <i className="bi bi-x-circle-fill text-danger"></i> : <i className="bi bi-exclamation-triangle-fill text-warning"></i>}
            </span>
            <span>{toast.message}</span>
            <button onClick={()=>setToast(p=>({...p,show:false}))} style={{marginLeft:'auto',background:'none',border:'none',color:'rgba(255,255,255,0.7)',cursor:'pointer',fontSize:'1.2rem',padding:0,lineHeight:1}}><i className="bi bi-x"></i></button>
          </div>
        </div>
      )}

      {/* Auto-hide toast */}
      {toast.show && setTimeout(()=>setToast(p=>({...p,show:false})), 4000) && null}

    </div>
  );
};

export default SetupBridging;
